<template>
  <div class="trial-calendar">
    <div class="trial-calendar-content">
      <h1>{{ $t('Proefles reserveren') }}</h1>
      <div v-if="trialReservations && Object.values(trialReservations).length">
        <h2>{{ $t('Mijn proeflessen') }}</h2>
        <Planning v-for="(data, index) in trialReservations" :key="index" :data="data" @cancel="cancel" />
      </div>
      <div class="trial-calendar-wrapper-calendar-events">
        <div>
          <h2>{{ $t('Kies een datum') }}</h2>
          <Calendar :events="events" v-model="selectedDay" showNextEvent />
        </div>
        <div v-if="selectedDay">
          <h2>{{ $t('Kies een tijdstip') }}</h2>
          <div class="events" v-if="selectedDay.events && selectedDay.events.length">
            <TrialCalendarEvent v-for="(event, index) in selectedDay.events" :key="index" v-model="selectedReservation" :event="event" />
          </div>
          <Alert :title="$t('Geen sessies gevonden')" v-else>{{ $t('Geen sessies op deze dag, kies een andere dag die aangeduid staat als beschikbaar.') }}</Alert>
        </div>
      </div>
    </div>
    <Card primary fill class="reservation" :title="$t('Jouw reservatie')">
      <List>
        <ListItem v-if="selectedUser" icon="id-badge">{{ selectedUser.name }}</ListItem>
        <ListItem v-if="selectedDay" icon="calendar">{{ selectedDay.date.format('dddd DD MMMM YYYY') }}</ListItem>
        <ListItem v-if="selectedReservation" icon="clock">{{ selectedReservation.startTime }} - {{ selectedReservation.endTime }}</ListItem>
        <ListItem icon="euro-sign">{{ tariff.price|money(false) }}/{{ $t('sessie') }}</ListItem>
      </List>
      <Alert type="danger" v-if="courseHasMaxReservations && (!selectedReservation || (selectedReservation && !isSelectedReserved) && !loading)" :title="$t('Cursus volzet')">
        {{ $t('Deze cursus heeft het maximum aantal proefles reservaties bereikt.') }}
      </Alert>
      <Alert type="danger" v-else-if="selectedDay && selectedReservation && selectedReservation.availability === 0 && !isSelectedReserved && !loading" :title="$t('Sessie volzet')">
        {{ $t('Deze sessie is volzet, kies een andere sessie') }}
      </Alert>
      <Alert type="danger" v-else-if="selectedDay && selectedReservation && userHasMaxReservations && !isSelectedReserved && !loading" :title="$t('Maximum proeflessen')">
        {{ this.selectedUser.name + $t(' heeft het maximum aantal proeflessen bereikt voor deze cursus') }}
      </Alert>
      <Button v-else-if="!user" danger fill @click="$router.push({ name: 'Login' })">{{ $t('Inloggen') }}</Button>
      <UserSelect success v-else-if="!selectedUser">{{ $t('Kies gebruiker') }}</UserSelect>
      <Button v-else-if="(selectedDay && selectedReservation && !isSelectedReserved && !userHasMaxReservations) || loading" success fill :icon="trials.includes(selectedReservation.nid) ? '' : 'plus'" @click="reserve" :disabled="!!trials.includes(selectedReservation.nid)" :loading="loading">{{ trials.includes(selectedReservation.nid) ? (loading ? $t('Toevoegen aan winkelmand') : $t('Al toegevoegd aan winkelmand')) : $t('In winkelmand') }}</Button>
      <Button v-else-if="(selectedDay && selectedReservation && isSelectedReserved) || cancelLoading" danger fill @click="cancel" :loading="cancelLoading">{{ $t('Annuleer proefles') }}</Button>
    </Card>
  </div>
</template>

<script>
import Calendar from '../Calendar/Index'
import Card from '../Core/Card'
import Button from '../Core/Button'
import Alert from '../Core/Alert'
import TrialCalendarEvent from './TrialCalendarEvent'
import List from '../Core/List'
import ListItem from '../Core/ListItem'
import UserSelect from '../Core/UserSelect'
import api from '../../api'
import Planning from "../Core/Planning.vue";
export default {
  name: 'TrialCalendar',
  components: {
    Planning,
    UserSelect,
    ListItem,
    List,
    TrialCalendarEvent,
    Alert,
    Button,
    Card,
    Calendar
  },
  props: {
    events: Array,
    course: Object,
    tariff: Object,
    reservationsPerUser: Object,
    availableReservations: Number,
    loading: Boolean,
    cancelLoading: Boolean
  },
  data () {
    return {
      selectedDay: false,
      selectedReservation: false,
      credit: 0,
      passReloadDeactivated: false
    }
  },
  computed: {
    club () {
      return this.$store.getters['club/club']
    },
    user () {
      return this.$store.getters['user/user']
    },
    selectedUser () {
      return this.$store.getters['user/selectedUser']
    },
    trials () {
      return this.$store.getters['cart/trials']
    },
    isSelectedReserved () {
      if (!this.selectedReservation || !this.selectedReservation.reservations) {
        return false
      }
      return this.selectedReservation.reservations.find(reservation => {
        return parseInt(reservation.uid) === parseInt(this.selectedUser.uid)
      })
    },
    isSelectedInCart () {
      if (!this.selectedReservation || !this.trials.length) return false
      return this.trials.includes(this.selectedReservation.nid)
    },
    userHasMaxReservations () {
      if (!this.reservationsPerUser) return false
      const reservations = this.reservationsPerUser[this.selectedUser.uid] ? parseInt(this.reservationsPerUser[this.selectedUser.uid]) + this.courseTrialsInCart : this.courseTrialsInCart
      return reservations >= parseInt(this.course.trialMaxSessionsPerUser)
    },
    courseHasMaxReservations () {
      if (this.availableReservations) return false
      if (!isNaN(this.availableReservations) && (parseInt(this.availableReservations) - this.courseTrialsInCart) <= 0) return true
      return true
    },
    courseTrialsInCart () {
      let count = 0
      this.trials.forEach((trialSessionId) => {
        let exists = this.tariff.sessions.find((session) => parseInt(trialSessionId) === parseInt(session.nid))
        if (exists) count++
      })
      return count
    },
    trialReservations () {
      if (!this.events.length) return {}

      return this.events.filter((event) => event.reservations.length && event.reservations.find((reservation) => reservation.uid === this.selectedUser.uid)).map((event) => {
        return {
          date: event.date.format('DD MMM YYYY'),
          sessions: event.reservations.filter((reservation) => reservation.uid === this.selectedUser.uid).map((reservation) => {
            return {
              ...event,
              from: event.startTime,
              to: event.endTime,
              user: reservation.name,
              club: this.club,
              label: this.course.title,
              canCancel: 1
            }
          })
        }
      })
    }
  },
  watch: {
    selectedDay () {
      this.selectedReservation = false
      // Select the first one if only one
      if (this.selectedDay && this.selectedDay.events && this.selectedDay.events.length === 1) {
        this.selectedReservation = this.selectedDay.events[0]
      }

      if (this.selectedDay && this.selectedDay.events.length) {
        this.$router.replace({
          query: {
            nid: this.selectedDay.events[0].nid,
            date: this.selectedDay.date.unix(),
            noScroll: 1
          }
        })
      }
    }
  },
  methods: {
    async reserve () {
      if (this.trials.includes(this.selectedReservation.nid)) {
        this.$store.commit('notice/addNotices', {
          title: 'Al toegevoegd aan winkelmandje',
          message: 'De geselecteerde sessie is al toegevoegd aan het winkelmandje',
          type: 'info'
        })
        return
      }

      this.$emit('submit', {
        course: this.course.nid,
        tariff: this.tariff.nid,
        session: this.selectedReservation.nid,
        uid: this.selectedUser.uid
      })
    },
    async cancel (session = false) {
      const sessionNid = session && session.nid ? session.nid : this.selectedReservation.nid
      this.$emit('cancel', {
        tariff: this.tariff.nid,
        session: sessionNid,
        uid: this.selectedUser.uid
      })
      this.selectedDay = false
      this.selectedReservation = false
    }
  }
}
</script>

<style lang="scss">
.trial-calendar {
  display: flex;
  margin-bottom: 1rem;

  & > div:not(:last-child) {
    margin-right: 1rem;
  }
}
.trial-calendar-content {
  flex-grow: 1;
}
.trial-calendar-wrapper-calendar-events {
  display: grid;
  grid-gap: 1rem;
}
.trial-calendar .reservation {
  width: auto;
}
@media screen and (max-width: 768px) {
  .trial-calendar {
    flex-wrap: wrap;
  }
}

@media screen and (min-width: 768px) {
  .trial-calendar-wrapper-calendar-events {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>

